(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alert-rules', {
            parent: 'alerting',
            url: '/rules?page&sort',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.alertRules.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/alert-rules/alert-rules.html',
                    controller: 'AlertRulesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    squash: true
                },
                systemPage: {
                    value: '1',
                    squash: true
                },
                systemSort: {
                    squash: true
                },
                fleet: {
                    value: -1,
                    fleetName: true
                },
                objectType:{
                    value: -1,
                    squash: true
                },
                search: null,
                predicates : {},
                systemPredicates : {},
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                        systemSort: $stateParams.systemSort,
                        predicates : $stateParams.predicates,
                        systemPredicates : $stateParams.systemPredicates,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('alertRules');
                    $translatePartialLoader.addPart('warning');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                domain: ['TabDomains', function(TabDomains) {
                    return  TabDomains.current();
                }]
            }
        });
    }

})();
